import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.suggested-products' ).each( ( key, element ) => {
        const slider = new Splide( element.querySelector( '.suggested-products-slider' ), {
          type: 'slide',
          perPage: 4,
          arrows: false,
          pagination: false,
          breakpoints: {
            640: {
              perPage: 1,
            },
            786: {
              perPage: 2,
            },
            1270: {
              perPage: 3,
            },
          },
        } ).mount();

        $( element ).find( '.suggested-products-slider-nav-prev' ).on( 'click', function() {
          slider.go( '-${i}' );
        } );

        $( element ).find( '.suggested-products-slider-nav-next' ).on( 'click', function() {
          slider.go( '+${i}' );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'suggested-products', COMPONENT );
} )( app );
